import React from 'react';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => {
  return (
    <div className={`animate-pulse bg-dark-600 rounded ${className}`} />
  );
};

export const StatCardSkeleton: React.FC = () => {
  return (
    <div className="p-6 rounded-2xl bg-dark-700/50 border border-dark-500/50">
      <div className="flex items-center justify-between mb-4">
        <Skeleton className="w-12 h-12 rounded-xl" />
        <Skeleton className="w-16 h-6 rounded-full" />
      </div>
      <Skeleton className="w-24 h-8 mb-2" />
      <Skeleton className="w-32 h-4" />
    </div>
  );
};

export const OrderRowSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-3 px-6 py-4">
      <Skeleton className="w-20 h-5" />
      <Skeleton className="w-16 h-5" />
      <Skeleton className="w-12 h-5" />
    </div>
  );
};

export const ActivitySkeleton: React.FC = () => {
  return (
    <div className="flex items-center gap-4 px-6 py-4">
      <Skeleton className="w-10 h-10 rounded-xl" />
      <div className="flex-1">
        <Skeleton className="w-24 h-5 mb-2" />
        <Skeleton className="w-32 h-4" />
      </div>
      <div className="text-right">
        <Skeleton className="w-20 h-5 mb-2 ml-auto" />
        <Skeleton className="w-16 h-4 ml-auto" />
      </div>
    </div>
  );
};

export default Skeleton;
